import { constructValue } from '@adornis/baseql/entities/construct.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { mongo } from '@adornis/buchungsheld-db/server/mongo.js';
import { GlobalConfig } from '../entities/global-config.js';

export const getGlobalConfig = registerQuery({
  operationName: 'getGlobalConfig',
  type: () => GlobalConfig,
  resolve:
    () =>
    async (gqlFields: BaseQLSelectionSet<GlobalConfig>): Promise<GlobalConfig> => {
      const coll = mongo().collection<Partial<EntityData<GlobalConfig>>>(GlobalConfig._collectionName);
      const query = { _id: 'SINGLETON', _class: GlobalConfig._class };
      const existsAlready = await coll.findOne(query);
      if (existsAlready) return constructValue(existsAlready);
      await coll.insertOne(query);
      return constructValue(await coll.findOne(query));
    },
});
